var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "canvas",
      class: { disabled: !_vm.editing },
      on: { click: _vm.deselect }
    },
    [_c("div", { ref: "canvas", staticClass: "u-tile" })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }